import { render } from "./Navigation.vue?vue&type=template&id=e88965a6"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui-components/Navigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e88965a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e88965a6', __exports__)) {
    api.reload('e88965a6', __exports__)
  }
  
  module.hot.accept("./Navigation.vue?vue&type=template&id=e88965a6", () => {
    api.rerender('e88965a6', render)
  })

}


export default __exports__